import { render, staticRenderFns } from "./PostsDisplay.vue?vue&type=template&id=1b6b562d&scoped=true"
import script from "./PostsDisplay.vue?vue&type=script&lang=js"
export * from "./PostsDisplay.vue?vue&type=script&lang=js"
import style0 from "./PostsDisplay.vue?vue&type=style&index=0&id=1b6b562d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6b562d",
  null
  
)

export default component.exports